var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box info-box"},[_c('div',{staticClass:"label font-weight-medium mr-3",domProps:{"innerHTML":_vm._s(_vm.label)}}),_c('strong',{staticClass:"font-weight-medium"},[_vm._v(_vm._s(_vm.value))])])}
var staticRenderFns = []

export { render, staticRenderFns }